import { render, staticRenderFns } from "./CollectionProtocolEvents.vue?vue&type=template&id=7e3035a2&scoped=true&"
import script from "./CollectionProtocolEvents.vue?vue&type=script&lang=js&"
export * from "./CollectionProtocolEvents.vue?vue&type=script&lang=js&"
import style0 from "./CollectionProtocolEvents.vue?vue&type=style&index=0&id=7e3035a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3035a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VAutocomplete,VBtn,VForm,VIcon,VProgressCircular,VSelect,VSpacer,VTextField,VTreeview})
